import { render, staticRenderFns } from "./CollapseText.vue?vue&type=template&id=ff1f8284&scoped=true"
import script from "./CollapseText.vue?vue&type=script&lang=js"
export * from "./CollapseText.vue?vue&type=script&lang=js"
import style0 from "./CollapseText.vue?vue&type=style&index=0&id=ff1f8284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1f8284",
  null
  
)

export default component.exports